import React from "react";
import { createStyles, WithStyles, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";

export interface AboutProps extends WithStyles<typeof styles> {}

const styles = createStyles({
  about: {
    maxWidth: "500px",
    textAlign: "center"
  },
  aboutTitle: {
    margin: "48px 0 24px"
  }
});

const About = ({ classes }: AboutProps) => (
  <>
    <Typography variant="h6" color="inherit" className={classes.aboutTitle}>
      About Figma-FSM
    </Typography>
    <Typography variant="body1" color="inherit" className={classes.about}>
      <Link
        href="https://en.wikipedia.org/wiki/Finite-state_machine"
        color="secondary"
        target="_blank"
      >
        Finite State Machines
      </Link>{" "}
      can represent our UX intention. And since Figma gives us access to so much information on our
      prototypes, it made sense to build a tool that would allow us to visualize our prototypes in
      FSM terms. This project was inspired by{" "}
      <Link color="secondary" href="https://xstate.js.org/" target="_blank">
        XState
      </Link>
      , a wonderful JS library that can help us represent FSM in our code.
    </Typography>
  </>
);

export default withStyles(styles)(About);
